export type Variant = "lending" | "pfm";

export const ALL_VARIANTS: Variant[] = ["lending", "pfm"];

export const VARIANT_LABELS: Record<Variant, string> = {
  lending: "Lending",
  pfm: "PFM",
};

export interface IPage {
  title: string;
  href: string;
  children?: IPage[];
  tags?: Variant[];
}

export const allPages: IPage[] = [
  {
    title: "Home",
    href: "/",
  },
  {
    title: "Finsense",
    href: "/finsense",

    children: [
      {
        title: "Authentication",
        href: "/finsense#auth",
      },
      {
        title: "Consent Flow",
        href: "/finsense#consent-flow",
      },
      {
        title: "Data Flow",
        href: "/finsense#data-flow",
      },
      {
        title: "Supporting APIs",
        href: "/finsense#supporting-apis",
      },
      {
        title: "Metrics API",
        href: "/finsense#metrics-api",
      },
      {
        title: "Notification",
        href: "/finsense#notification",
      },
      {
        title: "RBiH",
        href: "/finsense#rbih",
      },
      {
        title: "AA Switch API",
        href: "/finsense#aa-switch-api",
      },
    ],
  },
  {
    title: "ConnectHub",
    href: "/connect-hub",
  },
  {
    title: "WealthScape",
    href: "/wealth-scape",
    tags: ["pfm"],
    children: [
      {
        title: "Authentication",
        href: "/wealth-scape#auth",
      },
      {
        title: "Login",
        href: "/wealth-scape#login",
      },
      {
        title: "Subscription",
        href: "/wealth-scape#subscription",
      },
      {
        title: "AA Connect",
        href: "/wealth-scape#aa-connect",
      },
      {
        title: "MFC Connect",
        href: "/wealth-scape#mfc-connect",
      },
      {
        title: "Notifications",
        href: "/wealth-scape#notifications",
      },
      {
        title: "Net Worth",
        href: "/wealth-scape#networth",
      },
      {
        title: "Deposit Insights",
        href: "/wealth-scape#deposit-insights",
      },
      {
        title: "Mutual Fund Insights",
        href: "/wealth-scape#mutual-fund-insights",
      },
      {
        title: "Demat Insights",
        href: "/wealth-scape#demat-insights",
      },
      {
        title: "Equity Insights",
        href: "/wealth-scape#equity-insights",
      },
      {
        title: "ETF Insights",
        href: "/wealth-scape#etf-insights",
      },
      {
        title: "Equity & ETF Insights",
        href: "/wealth-scape#equity-etf-insights",
      },
      {
        title: "NPS Insights",
        href: "/wealth-scape#nps-insights",
      },
      {
        title: "Recurring Deposit Insights",
        href: "/wealth-scape#recurring-deposit-insights",
      },
      {
        title: "Term Deposit Insights",
        href: "/wealth-scape#term-deposit-insights",
      },
      {
        title: "Insurance Insights",
        href: "/wealth-scape#insurance-insights",
      },
      {
        title: "Credit Data",
        href: "/wealth-scape#credit-data",
      },
      {
        title: "F&O",
        href: "/wealth-scape#fno",
      },
      {
        title: "Nudges & Cohorts",
        href: "/wealth-scape#nudges-and-cohorts",
      },
      {
        title: "Others",
        href: "/wealth-scape#others",
      },
    ],
  },
  {
    title: "Prism",
    href: "/prism",
    children: [],
  },
  {
    title: "Risk Gauge",
    href: "/risk-gauge",
    tags: ["lending"],
    children: [
      {
        title: "API Integration",
        href: "/risk-gauge#api-integration",
      },
      {
        title: "Encryption Support",
        href: "/risk-gauge#encryption-support",
      },
    ],
  },
  {
    title: "Consent Journey",
    href: "/consent-journey",
    tags: ["lending", "pfm"],
    children: [
      {
        title: "Who's Who",
        href: "/consent-journey#overview",
      },
      {
        title: "Principles",
        href: "/consent-journey#principles",
      },
      {
        title: "Five-Screen Journey",
        href: "/consent-journey#journey",
      },
      {
        title: "Under the Hood",
        href: "/consent-journey#behind-the-scenes",
      },
      {
        title: "Tips",
        href: "/consent-journey#best-practices",
      },
    ],
  },
  {
    title: "SimBanks (UAT)",
    href: "/simbanks",
    tags: ["lending", "pfm"],
    children: [
      {
        title: "Why SimBanks?",
        href: "/simbanks#why",
      },
      {
        title: "End-to-end flow",
        href: "/simbanks#flow",
      },
      {
        title: "FIP catalogue",
        href: "/simbanks#catalogue",
      },
      {
        title: "Do & don't",
        href: "/simbanks#do-dont",
      },
    ],
  },
];
